import { DEFAULT_API_ERROR_CODE } from "./errors";
import { ProcessedApiResponse } from "./interfaces";

export const getApiErrorResponse = <Data = undefined>(): ProcessedApiResponse<Data> => ({
  success: false,
  error: {
    code: DEFAULT_API_ERROR_CODE,
    msg: "",
  },
});
